export default __webpack_public_path__ + "static/media/house-green.ec9db60f.svg";